import React from "react"
import PropTypes from "prop-types"
import { Close24 } from "@carbon/icons-react"
import Confetti from "react-confetti"

const Modal = (props) => {
  const onClose = (e) => {
    e.preventDefault()
    if (props.onClose) {
      props.onClose(e)
    }
  }
  return (
    <div className={`modal modal--${props.show ? "visible" : "hidden"}`}>
      <div className='modal__bg' onClick={onClose}>
        {props.showConfetti && props.show ? (
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            colors={["#FFEF64"]}
            onClick={onClose}
          />
        ) : (
          null
        )}
      </div>
      <div className='modal__content'>
        <div className='modal__body'>{props.children}</div>
      </div>
    </div>
  )
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
}

Modal.defaultProps = {
  show: false,
  title: "",
}

export default Modal
